import { MarkdownContentArea } from '@riac/design-system';
import styled from 'styled-components';

export const GhostDoc = styled(MarkdownContentArea)`
  margin: 50px 0;
`;
